// This file was automatically generated from appchart.visitNote.GenericBillDialog.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.visitNote.GenericBillDialog');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.GenericBillDialog.serviceLocations = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var locList6039 = opt_data.serviceLocations;
  var locListLen6039 = locList6039.length;
  for (var locIndex6039 = 0; locIndex6039 < locListLen6039; locIndex6039++) {
    var locData6039 = locList6039[locIndex6039];
    output.append('<option value="', soy.$$escapeHtml(locData6039.id), '">', soy.$$escapeHtml(locData6039.name), (locData6039.placeOfService) ? ' (' + soy.$$escapeHtml(locData6039.placeOfService) + ')' : '', '</option>');
  }
  output.append((! opt_data.kareoIntegrated) ? '<option value="">--</option>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.GenericBillDialog.copayLog = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="el8SystemText">Recorded ', (soy.$$escapeHtml(opt_data.whenCollected)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.whenCollected)) : ''), ' by ', soy.$$escapeHtml(opt_data.createUserName), '</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.GenericBillDialog.mindreaderContainer = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="mr-dropdown el8ActionsMenuDialog padb10"><div class="mr-dropdown-content el8MRContainer"><div class="mr-results-info el8MRInformTextIMO"></div><div class="mr-results padb10"></div><div class="mr-bottom-text el8MRFloatingBottomContainer">CPT copyright 2021 American Medical Association. All rights reserved.</div></div></div>');
  if (!opt_sb) return output.toString();
};
